export const scrollToRef = {
	methods: {
		scrollToRef(refName) {
			this.$nextTick(() => {
				if(this.$refs[refName]) {
					if(typeof this.$refs[refName].scrollIntoView === 'function') {
						this.$refs[refName].scrollIntoView({ behavior: 'smooth' });
					}
					else if(this.$refs[refName].$el && typeof this.$refs[refName].$el.scrollIntoView === 'function') {
						this.$refs[refName].$el.scrollIntoView({ behavior: 'smooth' });
					}
					else {
						console.warn(`Ref named '${refName}' does not have scrollIntoView method`);
					}
				}
				else {
					console.warn(`Ref named '${refName}' does not exist`);
				}
			});
		},
	},
};

/**
 * Usage examples
 *
 * For DOM elements and Vue Components - ui-box, div, button, p...
 *
 * <template>
 *   <div ref="myDiv">Scroll to me</div>
 *   <button @click="scrollToRef('myDiv')">Scroll</button>
 * </template>
 */
